// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-block-container {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
  align-items: center;
  position: relative;
  justify-content: center;
  column-gap: 10px;
  width: 100%;
}
.status-block-container .status-info {
  position: absolute;
  padding: 5px 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 5px 20px 0px #EBEBEB;
  z-index: 10;
  top: -20px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s ease-in-out;
}
.status-block-container .status-info.show {
  opacity: 1;
  visibility: visible;
}
.status-block-container .status-info .close {
  position: absolute;
  right: 0px;
  top: -5px;
  cursor: pointer;
}
.status-block-container .show-message {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.status-block-container .show-message:hover {
  opacity: 0.75;
}
.status-block-container .status-label {
  width: 100px;
  min-height: 36px;
  border-radius: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: var(--secondary-color-1);
  font-weight: 600;
}
.status-block-container .status-checks {
  display: flex;
  justify-content: center;
  column-gap: 8px;
}
.status-block-container .status-checks > div {
  display: flex;
}
.status-block-container .status-checks > div > span {
  font-size: 14px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.status-block-container .status-checks > div > span.approved {
  color: #02B946;
}
.status-block-container .status-checks > div > span.waiting {
  color: #C9C9C9;
}
.status-block-container .status-checks > div > span.not-required {
  color: #BEBEBE;
}
.status-block-container .status-checks > div > svg {
  align-self: center;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .status-block-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: center;
  }
  .status-block-container .show-message {
    display: inline-block;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .status-block-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/ManageShowings/modules/StatusBlock/statusBlock.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AADJ;AAEI;EACI,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;AAAR;AACQ;EACI,UAAA;EACA,mBAAA;AACZ;AACQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AACZ;AAEI;EACI,eAAA;EACA,4BAAA;AAAR;AACQ;EACI,aAAA;AACZ;AAEI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;AAAR;AAEI;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AAAR;AACQ;EACI,aAAA;AACZ;AAAY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAEhB;AADgB;EACI,cAAA;AAGpB;AADgB;EACI,cAAA;AAGpB;AADgB;EACI,cAAA;AAGpB;AAAY;EACI,kBAAA;AAEhB;;ACtEY;ED2ER;IACI,aAAA;IACA,sBAAA;IACA,qBAAA;IACA,kBAAA;EADN;EAEM;IACI,qBAAA;EAAV;AACF;AC3EY;EDgFR;IACI,aAAA;IACA,sBAAA;IACA,mBAAA;EAFN;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.status-block-container {\r\n    display: flex;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    align-items: center;\r\n    position: relative;\r\n    justify-content: center;\r\n    column-gap: 10px;\r\n    width: 100%;\r\n    .status-info {\r\n        position: absolute;\r\n        padding: 5px 20px;\r\n        background-color: white;\r\n        border-radius: 8px;\r\n        box-shadow: 0px 5px 20px 0px #EBEBEB;\r\n        z-index: 10;\r\n        top: -20px;\r\n        opacity: 0;\r\n        visibility: hidden;\r\n        transition: .3s ease-in-out;\r\n        &.show {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n        .close {\r\n            position: absolute;\r\n            right: 0px;\r\n            top: -5px;\r\n            cursor: pointer;\r\n        }\r\n    }                        \r\n    .show-message {\r\n        cursor: pointer;\r\n        transition: .2s ease-in-out;\r\n        &:hover {\r\n            opacity: .75;\r\n        }\r\n    }      \r\n    .status-label {\r\n        width: 100px;\r\n        min-height: 36px;\r\n        border-radius: 5px;\r\n        align-items: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        font-size: 12px;\r\n        color: var(--secondary-color-1);\r\n        font-weight: 600;\r\n    }\r\n    .status-checks {\r\n        display: flex;\r\n        justify-content: center;\r\n        column-gap: 8px;\r\n        > div { \r\n            display: flex;\r\n            > span {\r\n                font-size: 14px;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-1);\r\n                &.approved {\r\n                    color: #02B946;\r\n                }\r\n                &.waiting {\r\n                    color: #C9C9C9;\r\n                }\r\n                &.not-required {\r\n                    color: #BEBEBE;\r\n                }\r\n            }\r\n            > svg {\r\n                align-self: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .status-block-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-end;\r\n        text-align: center;\r\n        .show-message {\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .status-block-container {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
